import React, { useEffect, useState } from 'react';
import { Container } from '../ui/Container';
import { Section } from '../ui/Section';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';
export function TestimonialCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);
  const testimonials = [{
    quote: 'The team at Digital Printing Oz made ordering business cards so easy. Fast turnaround and the quality exceeded expectations!',
    author: 'Sarah M.',
    role: 'Café Owner',
    rating: 5,
    color: 'from-cyan-50 to-white'
  }, {
    quote: 'Our new shop signage looks incredible. From design to installation, they handled everything professionally. Highly recommended!',
    author: 'James T.',
    role: 'Retail Manager',
    rating: 5,
    color: 'from-magenta-50 to-white'
  }, {
    quote: "I've been using them for all our marketing materials for 2 years. Reliable, quality printing every time. The free proofs are a lifesaver.",
    author: 'Michelle K.',
    role: 'Marketing Director',
    rating: 5,
    color: 'from-yellow-50 to-white'
  }];
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex(current => (current + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [testimonials.length]);
  const nextTestimonial = () => {
    setActiveIndex(current => (current + 1) % testimonials.length);
  };
  const prevTestimonial = () => {
    setActiveIndex(current => (current - 1 + testimonials.length) % testimonials.length);
  };
  return <Section className="bg-white relative overflow-hidden" data-id="element-363">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full bg-dots pointer-events-none" data-id="element-364"></div>

      <Container data-id="element-365">
        <div className="text-center mb-12" data-id="element-366">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-367">
            Loved by{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-500 to-magenta-500" data-id="element-368">
              Aussie Businesses
            </span>
          </h2>
          <div className="flex justify-center gap-1 mb-2" data-id="element-369">
            {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-6 w-6 text-yellow-400 fill-current" data-id="element-370" />)}
          </div>
          <p className="text-gray-600" data-id="element-371">4.9/5 Average Rating</p>
        </div>

        <div className="relative max-w-4xl mx-auto" data-id="element-372">
          {/* Navigation Buttons */}
          <button onClick={prevTestimonial} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-12 z-10 p-2 rounded-full bg-white shadow-lg text-gray-400 hover:text-cyan-600 transition-colors hidden md:block" data-id="element-373">
            <ChevronLeft className="h-6 w-6" data-id="element-374" />
          </button>

          <button onClick={nextTestimonial} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-12 z-10 p-2 rounded-full bg-white shadow-lg text-gray-400 hover:text-cyan-600 transition-colors hidden md:block" data-id="element-375">
            <ChevronRight className="h-6 w-6" data-id="element-376" />
          </button>

          {/* Cards Container */}
          <div className="overflow-hidden relative h-[300px] md:h-[250px]" data-id="element-377">
            {testimonials.map((testimonial, index) => {
            // Calculate position relative to active index
            let position = 'translate-x-full opacity-0';
            if (index === activeIndex) position = 'translate-x-0 opacity-100';
            if (index === (activeIndex - 1 + testimonials.length) % testimonials.length) position = '-translate-x-full opacity-0';
            return <div key={index} className={`absolute top-0 left-0 w-full h-full transition-all duration-500 ease-in-out transform ${position}`} data-id="element-378">
                  <div className={`bg-gradient-to-br ${testimonial.color} p-8 md:p-10 rounded-2xl shadow-sm border border-gray-100 h-full flex flex-col justify-center relative mx-4`} data-id="element-379">
                    <Quote className="absolute top-6 left-6 h-10 w-10 text-gray-200 rotate-180" data-id="element-380" />

                    <div className="relative z-10 text-center" data-id="element-381">
                      <p className="text-lg md:text-xl text-gray-700 italic mb-6 leading-relaxed" data-id="element-382">
                        "{testimonial.quote}"
                      </p>

                      <div className="flex flex-col items-center" data-id="element-383">
                        <div className="font-bold text-gray-900" data-id="element-384">
                          {testimonial.author}
                        </div>
                        <div className="text-sm text-cyan-600 font-medium" data-id="element-385">
                          {testimonial.role}
                        </div>
                        <div className="flex gap-0.5 mt-2" data-id="element-386">
                          {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="h-4 w-4 text-yellow-400 fill-current" data-id="element-387" />)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>;
          })}
          </div>

          {/* Dots Navigation */}
          <div className="flex justify-center gap-2 mt-8" data-id="element-388">
            {testimonials.map((_, index) => <button key={index} onClick={() => setActiveIndex(index)} className={`h-2.5 rounded-full transition-all duration-300 ${index === activeIndex ? 'w-8 bg-cyan-500' : 'w-2.5 bg-gray-300 hover:bg-cyan-300'}`} aria-label={`Go to testimonial ${index + 1}`} data-id="element-389" />)}
          </div>
        </div>
      </Container>
    </Section>;
}